import React from "react";
import { Link } from "react-router-dom";
import { isDemoUrl, isYouTubeUrl } from "../../utils/url-detection";
import { useLocalizedUrl } from "../../hooks/useLocalizedUrl";
import { NavItem } from "./NavItem";

export type MobileNavigationItemProps = {
    item: NavItem;
    onClose?: () => void;
};

export const MobileNavigationItem: React.FC<MobileNavigationItemProps> = ({ item, onClose }) => {
    const localizedHref = useLocalizedUrl(item.href || "/");

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        // Check if this is a demo URL or YouTube URL
        if (item.href && (isDemoUrl(item.href) || isYouTubeUrl(item.href))) {
            e.preventDefault();
            // Dispatch custom event for demo/video URLs
            const event = new CustomEvent("navigation-demo-click", {
                detail: { url: item.href, type: isDemoUrl(item.href) ? "demo" : "video" },
            });
            window.dispatchEvent(event);
        }
        // Close the menu when a navigation link is clicked
        onClose?.();
    };

    return (
        <Link
            to={localizedHref}
            // eslint-disable-next-line max-len
            className="flex items-center py-4 px-2 text-white text-lg font-medium border-b border-white/10 min-h-[56px] active:bg-white/10 transition-colors"
            data-testid={`mobile-nav-item-${item.href}`}
            onClick={handleClick}
        >
            {item.title}
        </Link>
    );
};

export default MobileNavigationItem;
